import type { NavItem, SocialLink } from '../types/content';

export const site = {
  name: 'Bates Taekwondo',
  logo: 'https://cdn.magicpatterns.com/uploads/r2Xg9TBwzZHU4YYGnmDDu3/bates-black-shirt-transparent.png',
  street: '2820 Richmond Dr NE',
  cityLine: 'Albuquerque, NM 87107',
  phoneDisplay: '(505) 985-9091',
  phoneHref: 'tel:+15059859091',
  email: 'batestkd@gmail.com',
  emailHref: 'mailto:batestkd@gmail.com',
  directionsUrl:
    'https://www.google.com/maps/dir/?api=1&destination=2820%20Richmond%20Dr%20NE%2C%20Albuquerque%2C%20NM%2087107',
  trialFormUrl: 'https://www.batestkd.com/free-trial-class',
  testimonialsUrl: 'https://www.batestkd.com/testimonials',
};

export const photos = {
  clubGroup: 'https://static.wixstatic.com/media/37c34b_a33240d271fa4060b07024b9c6a7ff2b~mv2.jpg',
  coachKneeling: 'https://static.wixstatic.com/media/37c34b_12383dcdf7c44ec492a8e2a0d5e41306~mv2.jpg',
  littleBraves: 'https://static.wixstatic.com/media/37c34b_6fdec3490f074c288a1ce8cc078d51be~mv2.jpeg',
  advancedCompetition: 'https://static.wixstatic.com/media/61e59f_011502f0598e49558b4ce49ec7cf3629~mv2.jpg',
  mentorMoment: 'https://static.wixstatic.com/media/37c34b_4c5dc357b54b461c8989eb53b14f5d96~mv2.jpg',
  medal: 'https://static.wixstatic.com/media/37c34b_cadf5d62aa0546deb1142f0cc71254c4~mv2.jpg',
  team: 'https://static.wixstatic.com/media/37c34b_a33240d271fa4060b07024b9c6a7ff2b~mv2.jpg',
  coachPortrait: 'https://static.wixstatic.com/media/37c34b_be8fe0cc43c2441bb23b7f7b147b883f~mv2.jpg',
  adultsTraining: 'https://static.wixstatic.com/media/61e59f_37f5fba21ed14ce5a207a9a9807160bf~mv2.jpg',
};

export const navItems: NavItem[] = [
  { id: 'programs', label: 'Programs' },
  { id: 'why-bates', label: 'Why Bates' },
  { id: 'coach', label: 'Our Coach' },
  { id: 'visit', label: 'Visit Us' },
];

export const trustItems = [
  {
    "key": "roots",
    "label": "Local roots",
    "title": "Serving Albuquerque",
    "description": "Family-owned. Serving families since 2015.",
    "sources": [
      {
        "label": "School history",
        "url": "https://www.batestkd.com/"
      }
    ]
  },
  {
    "key": "experience",
    "label": "National-level instruction",
    "title": "2026 U.S. National Champion",
    "description": "Instructor Chaney Cecil · Senior & U21 gold.",
    "sources": [
      {
        "label": "Senior results",
        "url": "https://assets.contentstack.io/v3/assets/blteb7d012fc7ebef7f/blt90834ae564ba27ef/6a5512600bf2ac08940eca51/Results_Medalists_by_weight_category_Day_3.pdf"
      },
      {
        "label": "Under-21 results",
        "url": "https://assets.contentstack.io/v3/assets/blteb7d012fc7ebef7f/bltb1bc724082657656/6a5a8a6015befe872d3a8e8f/Results-Medalists-by-weight-category-Day-5.pdf"
      }
    ]
  },
  {
    "key": "achievement",
    "label": "Proven coaching",
    "title": "Youth Olympic Bronze",
    "description": "Chee coached Jessie Bates to bronze in 2010.",
    "sources": [
      {
        "label": "Coaching story",
        "url": "https://www.batestkd.com/about-us"
      },
      {
        "label": "2010 result",
        "url": "https://www.olympedia.org/athletes/1302610"
      }
    ]
  }
] as const;

export const socials: SocialLink[] = [
  { name: 'instagram', label: 'Instagram', handle: '@batestaekwondo', href: 'https://www.instagram.com/batestaekwondo/' },
  { name: 'facebook', label: 'Facebook', handle: 'BatesTaekwondo', href: 'https://www.facebook.com/BatesTaekwondo' },
  { name: 'youtube', label: 'YouTube', handle: '@cheebates4461', href: 'https://www.youtube.com/@cheebates4461' },
  { name: 'tiktok', label: 'TikTok', handle: '@batestaekwondo', href: 'https://www.tiktok.com/@batestaekwondo' },
];
